<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户列表">
              <el-select filterable clearable class="ele-block" v-model="where.user_id" placeholder="请选择">
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select filterable clearable class="ele-block" v-model="where.channel_type_id" placeholder="请选择">
                <el-option
                  v-for="item in channelTypeList"
                  :key="item.ids"
                  :value="item.ids"
                  :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="代收列表">
              <el-select filterable clearable class="ele-block" v-model="where.channel_id" placeholder="请选择">
                <el-option
                  v-for="item in inchannelList"
                  :key="'in-' + item.id"
                  :value="item.id"
                  :label="item.up_channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="代付列表">
              <el-select filterable clearable class="ele-block" v-model="where.channel_id_out" placeholder="请选择">
                <el-option
                  v-for="item in outchannelList"
                  :key="'out-' + item.id"
                  :value="item.id"
                  :label="item.up_channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>成功条数(收): {{ summary.in_count }}</span>
        <span>金额(收): {{ summary.in_amount }}</span>
        <span>成功条数(付): {{ summary.out_count }}</span>
        <span>金额(付): {{ summary.out_amount }}</span>
        <span>盈利: {{ summary.yingli }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="loadData"
        :columns="columns"
        :need-page="false"
        height="calc(100vh - 360px)" />
    </el-card>
  </div>
</template>

<script>
import reconTime from '@/mixins/recon-time';

const EMPTY_SUMMARY = {
  in_count: 0,
  in_amount: '0.00',
  out_count: 0,
  out_amount: '0.00',
  yingli: '0.00'
};

export default {
  name: 'ChannelRecon',
  mixins: [reconTime],
  data() {
    return {
      columns: [
        { prop: 'channel_name', label: '通道分类', minWidth: 150, align: 'center', showOverflowTooltip: true },
        { prop: 'payincount', label: '成功条数(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_paymentAmount', label: '金额(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_fees', label: '费率(收)', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'in_rate', label: '手续费(收)', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'payoutcount', label: '成功条数(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_paymentAmount', label: '金额(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_fees', label: '费率(付)', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'out_rate', label: '手续费(付)', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'yingli', label: '盈利', minWidth: 100, align: 'center', showOverflowTooltip: true }
      ],
      where: {
        user_id: undefined,
        channel_type_id: undefined,
        channel_id: undefined,
        channel_id_out: undefined,
        time: null
      },
      inchannelList: [],
      outchannelList: [],
      channelTypeList: [],
      userList: [],
      summary: { ...EMPTY_SUMMARY }
    };
  },
  mounted() {
    this.getinChannelList();
    this.getoutChannelList();
    this.getChannelType();
    this.getUserList();
  },
  methods: {
    buildQuery(where) {
      const q = { ...where };
      // 后端目前共用 channel_id；代付优先传 channel_id_out 覆盖
      if (q.channel_id_out) {
        q.channel_id = q.channel_id_out;
      }
      delete q.channel_id_out;
      return q;
    },
    loadData(params, callback) {
      const where = (params && params.where) || this.where || {};
      this.$http
        .get('/Reconciliation/channel', { params: this.buildQuery(where) })
        .then((res) => {
          if (res.data.code !== 0) {
            this.summary = { ...EMPTY_SUMMARY };
            this.$message.error(res.data.msg);
            callback([]);
            return;
          }
          this.summary = { ...EMPTY_SUMMARY, ...(res.data.summary || {}) };
          callback(Array.isArray(res.data.data) ? res.data.data : []);
        })
        .catch((e) => {
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(e.message);
          callback([]);
        });
    },
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {
        user_id: undefined,
        channel_type_id: undefined,
        channel_id: undefined,
        channel_id_out: undefined,
        time: null
      };
      this.applyTimeQuick('today', true);
    },
    getChannelType() {
      this.$http.post('/Channeltype/getchannelTypeListGroup').then((res) => {
        if (res.data.code === 0) this.channelTypeList = res.data.data || [];
        else this.$message.error(res.data.msg);
      }).catch((e) => this.$message.error(e.message));
    },
    getUserList() {
      this.$http.post('/user/getUserList').then((res) => {
        if (res.data.code === 0) this.userList = res.data.data || [];
        else this.$message.error(res.data.msg);
      }).catch((e) => this.$message.error(e.message));
    },
    getinChannelList() {
      this.$http.post('/ChannelColumnIn/getchannelList').then((res) => {
        if (res.data.code === 0) this.inchannelList = res.data.data || [];
        else this.$message.error(res.data.msg);
      }).catch((e) => this.$message.error(e.message));
    },
    getoutChannelList() {
      this.$http.post('/ChannelColumnOut/getchannelList').then((res) => {
        if (res.data.code === 0) this.outchannelList = res.data.data || [];
        else this.$message.error(res.data.msg);
      }).catch((e) => this.$message.error(e.message));
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
